<script setup>
import { onBeforeUnmount, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const visible = ref(false);
let timer, pendingRoute;
function finish(to) {
  if (pendingRoute !== to) return;
  clearTimeout(timer);
  pendingRoute = undefined;
  visible.value = false;
}
const removeBefore = router.beforeEach(to => {
  clearTimeout(timer);
  pendingRoute = to;
  timer = setTimeout(() => { visible.value = true; }, 180);
});
const removeAfter = router.afterEach(to => finish(to));
const removeError = router.onError((_error, to) => finish(to));
onBeforeUnmount(() => {
  clearTimeout(timer);
  removeBefore(); removeAfter(); removeError();
});
</script>

<template>
  <div v-if="visible" class="route-progress" role="progressbar" aria-label="Открываем раздел"><span /></div>
</template>

<style scoped>
.route-progress { position: fixed; inset: 0 0 auto; z-index: 1800; height: 3px; overflow: hidden; pointer-events: none; background: var(--accent-soft); }
.route-progress span { display: block; width: 35%; height: 100%; border-radius: 999px; background: var(--accent); animation: route-progress 1.2s ease-in-out infinite; }
@keyframes route-progress { from { transform: translateX(-100%); } to { transform: translateX(390%); } }
@media (prefers-reduced-motion: reduce) { .route-progress span { width: 100%; animation: none; } }
</style>
